import MembershipConcernModalContainer from './MembershipConcernModalContainer';

export default MembershipConcernModalContainer;
